/**
 * MegaRTL Main Page - Section specific interactions
 */

(function () {
    function initMainPage() {
        // Add any page-specific initialization here
    }

    document.addEventListener('DOMContentLoaded', initMainPage);
    document.addEventListener('shopify:section:load', initMainPage);
})();
